import { FlexGrid } from "@grapecity/wijmo.react.grid";
import ReactJson from "react-json-view";

const TestWijmo = () => {
  // const [data, setData] = useState([]);
  // const [gridData, setGridData] = useState("");
  // const methods = useForm();

  // const downloadFile = async () => {
  //   try {
  //     const res = await getReportApiData({}, { responseType: "blob" });
  //     // console.log('resres', res);
  //     const blob = new Blob([res], { type: "application/pdf" });
  //     const link = document.createElement("a");
  //     link.href = window.URL.createObjectURL(blob);
  //     window.open(link.href);
  //   } catch (error) {
  //     console.error("error", error);
  //   }
  // };

  // const gridInit = (flex) => {
  //   flex.collapseGroupsToLevel(0);
  //   flex.columns?.forEach((c) => {
  //     if (c.binding === "id") c.visible = false;
  //   });

  //   flex.itemFormatter = (panel, r, c, cell) => {
  //     toggleClass(cell, "criteria", true);
  //   };

  //   flex.formatItem.addHandler((s, e) => {
  //     flex.onCellEditEnded = (e) => {
  //       const grid = e.panel.grid;
  //       const editingCol = grid.columns[e.col];
  //       const currentItem = grid.rows[e.row].dataItem;
  //       const value = currentItem?.selected;

  //       currentItem?.children.forEach((child) => {
  //         const rows = flex.rows;
  //         const updateRow = rows.find((r) => r.dataItem.id === child.id);
  //         flex.setCellData(updateRow.index, editingCol.index, value);
  //       });
  //     };
  //     var row = s.rows[e.row];
  //     if (s.cells === e.panel && row instanceof wjcGrid.GroupRow) {
  //       // remove this class to remove the icons
  //       var classToRemove =
  //         "wj-glyph-" + (row.isCollapsed ? "right" : "down-right");
  //       // change icon according to font awsome icons
  //       var classToAdd = row?.isCollapsed
  //         ? "fa-sharp fa-plus boldim"
  //         : "fa-minus boldim";
  //       var span = e.cell.querySelector("span." + classToRemove);
  //       if (span) {
  //         wjcCore.removeClass(span, classToRemove);
  //         wjcCore.createElement(`<i class="fa ${classToAdd}"></i>`, span);
  //       }
  //     }
  //   });
  // };

  // const gridLoadedRows = (flex) => {
  //   flex.rows.forEach((r) => {
  //     r.isReadOnly = false;
  //   });
  //   flex.columns.forEach((c) => {
  //     c.isReadOnly = true;
  //   });
  // };
  const gridInitialized = (flex) => {
    flex.hostElement.addEventListener("dblclick", (e) => {
      const ht = flex.hitTest(e.pageX, e.pageY);
      const view = ht?.grid?.collectionView;
      const currentItem = view?.currentItem;
      console.log(currentItem);
    });
  };

  return (
    <>
      <FlexGrid
        itemsSource={[
          {
            id: 7096,
            sku: "1477172",
            name: "CONVERSE GO-TO EMBROIDERED STAR CHEVRON FLEECE SHORT",
            attribute_set_id: 4,
            price: 0,
            status: 1,
            visibility: 4,
            type_id: "configurable",
            created_at: "2023-03-27 08:02:13",
            updated_at: "2023-03-28 08:29:06",
            weight: 0.5,
            extension_attributes: {
              website_ids: [1],
              category_links: [
                { position: 3, category_id: "5" },
                { position: 1, category_id: "115" },
                { position: 4, category_id: "126" },
                { position: 3, category_id: "139" },
                { position: 13, category_id: "254" },
              ],
              stock_item: {
                item_id: 9039,
                product_id: 7096,
                stock_id: 1,
                qty: 0,
                is_in_stock: true,
                is_qty_decimal: false,
                show_default_notification_message: false,
                use_config_min_qty: true,
                min_qty: 0,
                use_config_min_sale_qty: 1,
                min_sale_qty: 1,
                use_config_max_sale_qty: true,
                max_sale_qty: 10000,
                use_config_backorders: true,
                backorders: 0,
                use_config_notify_stock_qty: true,
                notify_stock_qty: 1,
                use_config_qty_increments: true,
                qty_increments: 0,
                use_config_enable_qty_inc: true,
                enable_qty_increments: false,
                use_config_manage_stock: true,
                manage_stock: true,
                low_stock_date: null,
                is_decimal_divided: false,
                stock_status_changed_auto: 0,
              },
              configurable_product_options: [
                {
                  id: 3041,
                  attribute_id: "93",
                  label: "Χρώμα",
                  position: 0,
                  values: [{ value_index: 263 }],
                  product_id: 7096,
                },
                {
                  id: 3042,
                  attribute_id: "137",
                  label: "Μέγεθος",
                  position: 0,
                  values: [
                    { value_index: 151 },
                    { value_index: 152 },
                    { value_index: 153 },
                    { value_index: 154 },
                    { value_index: 155 },
                    { value_index: 156 },
                  ],
                  product_id: 7096,
                },
              ],
              configurable_product_links: [7652, 7653, 7654, 7655, 7656, 7657],
            },
            options: [],
            media_gallery_entries: [],
            custom_attributes: [
              { attribute_code: "image", value: "no_selection" },
              {
                attribute_code: "url_key",
                value:
                  "converse-go-to-embroidered-star-chevron-fleece-short-10023875-a08",
              },
              { attribute_code: "small_image", value: "no_selection" },
              { attribute_code: "options_container", value: "container2" },
              { attribute_code: "thumbnail", value: "no_selection" },
              {
                attribute_code: "amasty_conf_flipper_image",
                value: "no_selection",
              },
              { attribute_code: "msrp_display_actual_price_type", value: "0" },
              { attribute_code: "tax_class_id", value: "2" },
              {
                attribute_code: "category_ids",
                value: ["5", "115", "126", "139", "254"],
              },
              { attribute_code: "required_options", value: "0" },
              { attribute_code: "has_options", value: "0" },
              { attribute_code: "upper", value: "56" },
              { attribute_code: "manufacturer", value: "85" },
              { attribute_code: "shoe_upper_style", value: "69" },
              { attribute_code: "new_arrivals", value: "0" },
              { attribute_code: "best_sellers", value: "0" },
              { attribute_code: "width", value: "59" },
              { attribute_code: "partnumber", value: "10023875-A08" },
              { attribute_code: "amasty_conf_matrix", value: "0" },
            ],
          },
        ]}
        initialized={gridInitialized}
      />

      <ReactJson
        name="example"
        src={{
          id: 7096,
          sku: "1477172",
          name: "CONVERSE GO-TO EMBROIDERED STAR CHEVRON FLEECE SHORT",
          attribute_set_id: 4,
          price: 0,
          status: 1,
          visibility: 4,
          type_id: "configurable",
          created_at: "2023-03-27 08:02:13",
          updated_at: "2023-03-28 08:29:06",
          weight: 0.5,
          extension_attributes: {
            website_ids: [1],
            category_links: [
              { position: 3, category_id: "5" },
              { position: 1, category_id: "115" },
              { position: 4, category_id: "126" },
              { position: 3, category_id: "139" },
              { position: 13, category_id: "254" },
            ],
            stock_item: {
              item_id: 9039,
              product_id: 7096,
              stock_id: 1,
              qty: 0,
              is_in_stock: true,
              is_qty_decimal: false,
              show_default_notification_message: false,
              use_config_min_qty: true,
              min_qty: 0,
              use_config_min_sale_qty: 1,
              min_sale_qty: 1,
              use_config_max_sale_qty: true,
              max_sale_qty: 10000,
              use_config_backorders: true,
              backorders: 0,
              use_config_notify_stock_qty: true,
              notify_stock_qty: 1,
              use_config_qty_increments: true,
              qty_increments: 0,
              use_config_enable_qty_inc: true,
              enable_qty_increments: false,
              use_config_manage_stock: true,
              manage_stock: true,
              low_stock_date: null,
              is_decimal_divided: false,
              stock_status_changed_auto: 0,
            },
            configurable_product_options: [
              {
                id: 3041,
                attribute_id: "93",
                label: "Χρώμα",
                position: 0,
                values: [{ value_index: 263 }],
                product_id: 7096,
              },
              {
                id: 3042,
                attribute_id: "137",
                label: "Μέγεθος",
                position: 0,
                values: [
                  { value_index: 151 },
                  { value_index: 152 },
                  { value_index: 153 },
                  { value_index: 154 },
                  { value_index: 155 },
                  { value_index: 156 },
                ],
                product_id: 7096,
              },
            ],
            configurable_product_links: [7652, 7653, 7654, 7655, 7656, 7657],
          },
          options: [],
          media_gallery_entries: [],
          custom_attributes: [
            { attribute_code: "image", value: "no_selection" },
            {
              attribute_code: "url_key",
              value:
                "converse-go-to-embroidered-star-chevron-fleece-short-10023875-a08",
            },
            { attribute_code: "small_image", value: "no_selection" },
            { attribute_code: "options_container", value: "container2" },
            { attribute_code: "thumbnail", value: "no_selection" },
            {
              attribute_code: "amasty_conf_flipper_image",
              value: "no_selection",
            },
            { attribute_code: "msrp_display_actual_price_type", value: "0" },
            { attribute_code: "tax_class_id", value: "2" },
            {
              attribute_code: "category_ids",
              value: ["5", "115", "126", "139", "254"],
            },
            { attribute_code: "required_options", value: "0" },
            { attribute_code: "has_options", value: "0" },
            { attribute_code: "upper", value: "56" },
            { attribute_code: "manufacturer", value: "85" },
            { attribute_code: "shoe_upper_style", value: "69" },
            { attribute_code: "new_arrivals", value: "0" },
            { attribute_code: "best_sellers", value: "0" },
            { attribute_code: "width", value: "59" },
            { attribute_code: "partnumber", value: "10023875-A08" },
            { attribute_code: "amasty_conf_matrix", value: "0" },
          ],
        }}
        collapsed={1}
      />
    </>
  );
};

export default TestWijmo;
